import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { initialState, type OnboardingState } from './model.ts';

// Keep the pending setup capability in this tab while the owner checks email.
// Blocked storage falls back to memory. Backend checks still gate workspace entry.
const storage = {
  getItem: (name: string) => {
    try {
      return sessionStorage.getItem(name);
    } catch {
      return null;
    }
  },
  setItem: (name: string, value: string) => {
    try {
      sessionStorage.setItem(name, value);
    } catch {
      /* memory only */
    }
  },
  removeItem: (name: string) => {
    try {
      sessionStorage.removeItem(name);
    } catch {
      /* memory only */
    }
  },
};
export const useOnboarding = create<OnboardingState>()(
  persist(() => initialState(), {
    name: 'traceira-pending-setup',
    storage: createJSONStorage(() => storage),
    merge: (saved, current) => {
      const state = { ...current, ...(saved as OnboardingState) };
      return {
        ...state,
        check: state.check === 'running' ? 'stopped' : state.check,
        workspace: state.workspace === 'creating' ? 'failed' : state.workspace,
        consent: state.consent?.statementVersion ? state.consent : null,
        consentSaving: false,
        server: { ...state.server, busy: false },
      };
    },
  }),
);

export function act(transition: (state: OnboardingState) => OnboardingState) {
  useOnboarding.setState(transition(useOnboarding.getState()), true);
}
